import { OrganizationSwitcher as BAUOrganizationSwitcher } from '@daveyplate/better-auth-ui';

import { cn } from '@/lib/utils';

type BAUProps = React.ComponentProps<typeof BAUOrganizationSwitcher>;

interface OrganizationSwitcherProps extends Omit<BAUProps, 'classNames'> {
  classNames?: Partial<BAUProps['classNames']>;
}

export function OrganizationSwitcher({ classNames, ...props }: OrganizationSwitcherProps) {
  return (
    <BAUOrganizationSwitcher
      classNames={{
        content: {
          base: 'organization-switcher-content',
        },
        ...classNames,
      }}
      {...props}
    />
  );
}
